import { isRef }      from 'vue';
import { createI18n } from 'vue-i18n';

export let i18n = null;

function isComposer( instance, mode )
{
    return mode === 'composition' && isRef( instance.locale );
}

export function hasDictionary( i18n, locale )
{
    return i18n.global.availableLocales.includes( locale );
}
 
export async function loadDictionary( i18n, locale )
{
    await loadLocaleMessages( i18n, locale );

    setI18nLanguage( i18n, locale );
}

export function getLocale( i18n )
{
    return isComposer( i18n.global, i18n.mode ) ? i18n.global.locale.value : i18n.global.locale;
}

export function setLocale( i18n, locale )
{
    return isComposer( i18n.global, i18n.mode ) ? i18n.global.locale.value = locale : i18n.global.locale = locale;
}

export async function setupI18n( options = { locale: 'en' } )
{
    i18n = createI18n( options );

    await loadLocaleMessages( i18n, options.locale ); 

    setI18nLanguage( i18n, options.locale );

    return i18n;
}

export function setI18nLanguage( i18n, locale )
{
    setLocale( i18n, locale )

    /**
    * NOTE:
    * If you need to specify the language setting for headers, such as the `fetch` API, set it here.
    * The following is an example for axios.
    *
    * axios.defaults.headers.common['Accept-Language'] = locale
    */

    document.querySelector('html').setAttribute('lang', locale );
}

export async function loadLocaleMessages( i18n, locale)
{
    // Use import.meta.glob to load files in locale subfolders
    const localeFiles = import.meta.glob('./locales/**/*.json');

    const matchedEntries = Object.entries( localeFiles ).filter( ([ path ]) => path.includes(`/locales/${locale}/`) );

    // Import only files from the current locale folder
    const localeImports = matchedEntries.map( ([ _, fileImport ]) => fileImport().then( ( module ) => module.default || module ));

    // Wait for all imports to resolve
    const messages = await Promise.all( localeImports );

    // Map them to the corresponding file names (without extension)
    const messageNames = Object.entries( localeFiles ).filter( ([ path ]) => path.includes(`/locales/${locale}/`)).reduce( ( acc, [ path ], index ) =>
    {
        const key = path.split('/').pop().replace('.json', '');
        const fileMessages = messages[ index ];

        if ( key === 'views' && fileMessages && fileMessages.views )
        {
            const merged = { ...fileMessages };
            for ( const [ k, v ] of Object.entries( fileMessages.views ) )
            {
                if ( merged[ k ] && typeof merged[ k ] === 'object' && typeof v === 'object' )
                {
                    merged[ k ] = { ...merged[ k ], ...v };
                }
                else
                {
                    merged[ k ] = v;
                }
            }
            acc[ key ] = merged;
        }
        else
        {
            acc[ key ] = fileMessages;
        }

        return acc;

    }, {});

    // Set the messages in i18n
    i18n.global.setLocaleMessage( locale, messageNames );
}

export function t( key, params )
{
    if( !i18n ) { return key; }

    return i18n.global.t( key, params );
}
